var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3C21.1 3 22 3.9 22 5V23L18 19H4C2.9 19 2 18.1 2 17V5C2 3.9 2.9 3 4 3H20ZM13.0003 12H16.0003C16.5503 12 17.0003 11.55 17.0003 11C17.0003 10.45 16.5503 10 16.0003 10H13.0003V7.00001C13.0003 6.45001 12.5503 6.00001 12.0003 6.00001C11.4503 6.00001 11.0003 6.45001 11.0003 7.00001V10H8.00034C7.45034 10 7.00034 10.45 7.00034 11C7.00034 11.55 7.45034 12 8.00034 12H11.0003V15C11.0003 15.55 11.4503 16 12.0003 16C12.5503 16 13.0003 15.55 13.0003 15V12Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAddComment);
export default __webpack_public_path__ + "static/media/default-add-comment.c24819fa.svg";
export { ForwardRef as ReactComponent };